<template>
  <div class="tree-box">
    <header v-show="headerShowUp && headerShow">
      <span class="title">{{ title }}</span>
      <el-dropdown>
        <i class="el-icon-setting"></i>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item @click.native="fresh">{{$t("leftTree.dropdown1")}}</el-dropdown-item>
          <el-dropdown-item @click.native="unFoldAll">{{$t("leftTree.dropdown2")}}</el-dropdown-item>
          <el-dropdown-item @click.native="collapseAll">{{$t("leftTree.dropdown3")}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </header>
    <div class="treesearch" v-show="headerShowDown || headerShow">
      <el-input v-if="showInput" :placeholder="placeholder" v-model="filterText" clearable
                suffix-icon='iconfont icon-search'></el-input>
    </div>
    <!--  check-strictly可配置 -->
    <div class="overauto">
      <el-tree
          ref="eltree"
          :props="defaultProps"
          :data="treeData"
          node-key="id"
          highlight-current
          :check-strictly="strictly"
          :expand-on-click-node="false"
          :default-expanded-keys="defExpandNode"
          :default-checked-keys="defCheckedNode"
          :show-checkbox="showCheckbox"
          @node-click="handleNodeClick"
          @check-change="handleCheckChange"
          @check="hanleCheck"
          :filter-node-method="filterNode"
          draggable
          :allow-drop="dragFalse">
                <span class="treeIcon" slot-scope="{ node,data }" @mouseenter.stop="editS($event)"
                      @mouseleave.stop="editH($event)">
                    <span><i class="iconfont" :class="data.icon"></i>{{ node.label }}</span>
                    <span v-if="treeEdit" class="editIcon">
                        <i v-if="data.iconCust.addIcon==undefined?true:data.iconCust.addIcon" class="el-icon-plus"
                           @click.stop="nodeAdd(node, data)"></i>
                        <i v-if="data.iconCust.editIcon==undefined?true:data.iconCust.editIcon" class="el-icon-edit"
                           @click.stop="nodeEdit(node, data)"></i>
                        <i v-if="data.iconCust.delIcon==undefined?true:data.iconCust.delIcon" class="el-icon-delete"
                           @click.stop="nodeDel(node, data)"></i>
                    </span>
                </span>
      </el-tree>
    </div>
  </div>
</template>

<script>
import {IsNull} from "@/config/validate/common"
let placeholder = localStorage.getItem('language-type') === "zh-CN"
                    ? "请输入检索内容" 
                    : "Please enter search content"
export default {
  name: "tree",
  props: {
    headerShow:{type: Boolean, default: true}, // 控制树名称和检索框是否显示
    headerShowUp: {type: Boolean, default: true}, 
    headerShowDown: {type: Boolean, default: true},
    title: {
      type: String,
      default: "组织树"
    },
    sourceData: { // 源数据
      type: Array,
      required: true,
    },
    formatTreeData: {
      required: true,
      default: () => (
          {
            id: "", // 映射节点id 必传
            label: "", // 映射节点名称 必传
            pcode: "", // 映射节点关系中的父节点code 必传
            code: '', // 映射节点code 必传
            nodetype: '', // 映射节点类型
            disabled: 'disabled', // 映射能否checkd
            extra: [], // 节点添加的额外属性
            iconCust: [], // 右侧编辑节点的三个icon
          }
      )
    },
    defExpandNode: {type: Array},
    defCheckedNode: {type: Array},
    lefticon: {
      type: String,
      default: 'icon-user'
    },
    treeEdit: {
      type: Boolean,
      default: false,
    }, // 是否可编辑
    showCheckbox: {
      type: Boolean,
      default: false,
    }, // 是否显示checkbox
    showInput: {
      type: Boolean,
      default: true,
    }, // 是否显示搜索框
    strictly: {
      type: Boolean,
      default: true
    }, // check的父子互不关联
    placeholder: {
      type: String,
      default: placeholder
    }
  },
  watch: {
    filterText(val) {
      val = val.replace(/(^\s+)|(\s+$)/g, "")
      if(val.length>1){
        this.$refs.eltree.filter(val);
      }else{
          if(val == ''){
            //   this.$emit('freshTreeData');
            //不重新刷新数据
            this.$refs.eltree.filter(val);
          }
      }
    },
    sourceData(val) {
      this.filterText = '';
      this.integratedData(val, this.formatTreeData)
    }
  },
  data() {
    return {
      treeData: [],  // 总的数据
      defaultProps: {
        label: 'label',
        children: 'children',
      },
      filterText: '', // 搜索框的value
      midData: new Map(), // 整合数据时需要借助的中间数据
    }
  },
  methods: {
    clearFilter(){
        this.filterText = '';
        this.$emit('freshTreeData');
    },
    fresh() {
      this.filterText = '';
      this.$emit('freshTreeData')
    },
    dragFalse(){
        return false
    },
    handleNodeClick(data,node,el) {
      this.$emit('clickTreeNode', data,node,el)
    },
    handleCheckChange(node, checked, indeterminate) {// 选中时的节点回调
      this.$emit('checkTreeNode', node, checked, indeterminate)
    },
    hanleCheck(data, checked) {
      this.$emit('checkNodeClick', data, checked)
    },
    getCurrentKey() { // 获取当前节点
      return this.$refs.eltree.getCurrentKey()
    },
    getCurrentNode() { // 也可以直接通过getNode获取
      return this.$refs.eltree.getCurrentNode()
    },
    setCurrentKey(key) { // 设置当前节点
      this.$refs.eltree.setCurrentKey(key)
    },
    getCheckedKeys() { // 获取勾选的节点
      return this.$refs.eltree.getCheckedKeys()
    },
    setCheckedKeys(keys) { // 设置勾选的节点
      this.$refs.eltree.setCheckedKeys(keys)
    },
    setChecked(key, checked, deep) { // 设置
      this.$refs.eltree.setChecked(key, checked, deep)
    },
    getNode(key) { // 获取node节点
      return this.$refs.eltree.getNode(key)
    },
    getCheckedNodes() {
      return this.$refs.eltree.getCheckedNodes();
    },
    getHalfCheckedNodes() {
      return this.$refs.eltree.getHalfCheckedNodes()
    },
    getParentKey(key) {
      let node = this.$refs.eltree.getNode(key)
      if (node.parent.label === undefined) {
        //    console.log('已经是根节点了')
        return
      }
      return node.parent.data.id
    },
    //获取上级节点lable（部门树）
    getParentLable(key) {
      let node = this.$refs.eltree.getNode(key)
      if (node.parent.label === undefined) {
        return "No"
      }
      return node.parent.data.label
    },
    nodeAdd(node, data) {
    }, // 节点添加
    nodeEdit(node, data) {
    }, // 节点编辑
    nodeDel(node, data) {
    }, // 节点删除
    filterNode(value, data) { // 节点过滤
      if (!value) return true;
      value = value.toLowerCase()
      return data.label.toLowerCase().indexOf(value) !== -1;
    },
    unFoldAll() { // 全部展开
      this.sourceData.forEach(data => {
        this.$refs.eltree.store.nodesMap[data[this.formatTreeData.id]].expanded = true
      });
    },
    collapseAll() { // 全部折叠
      this.sourceData.forEach(data => {
        this.$refs.eltree.store.nodesMap[data[this.formatTreeData.id]].expanded = false
      });
    },
    editS(ev) {
      if (this.treeEdit) {
        ev.target.children[1].style.display = "inline"
        if(ev.target.style.width === ''){ // 解决滑动超出宽度时编辑按钮不能点击的问题
            ev.target.style.width = ev.target.offsetWidth +'px'
        }
      }
    },
    editH(ev) {
      if (this.treeEdit) {
        ev.target.children[1].style.display = "none"
      }
    },
    // 下面开始整合数据
    integratedData(sourcelist, tjson) {
      this.formatTreeData.iconCust = ['delIcon', 'editIcon', 'addIcon'];
      //开始查找根节点
      let fictitiousRoot;
      let pCodeMap = new Map();
      let pCode;
      let code;
      sourcelist.forEach(item => {
        pCode = item[tjson['pcode']];
        code = item[tjson['code']];
        if(code === '0.'){
          
        }else if (!pCodeMap.has(pCode)) {
          pCodeMap.set(pCode, false);
        }
      });
      sourcelist.forEach(item => {
        code = item[tjson['code']];
        if(code === '0.'){
          
        }else if (pCodeMap.has(code)) {
          pCodeMap.set(code, true);
        }
      });
      let newData = [];
      sourcelist.forEach(item => {
        pCode = item[tjson['pcode']];
        code = item[tjson['code']];
        if(code === '0.'){
          let jsonData = this.complieSource(item, tjson);
          fictitiousRoot = jsonData;
        }else if (pCodeMap.get(pCode)) {
          if (this.midData.has(pCode)) {
            this.midData.get(pCode).push(item);
          } else {
            this.midData.set(pCode, [item]);
          }
        } else {
          let jsonData = this.complieSource(item, tjson);
          newData.push(jsonData);
        }
      });
      //递归整理数据
      let childTree = this.recursiveData(newData, tjson);
      let finalTree;
      if(fictitiousRoot != null){
        if(childTree != null && childTree.length > 0){
            fictitiousRoot.children = childTree;
        }
        finalTree = [];
        finalTree.push(fictitiousRoot);
      }else{
        finalTree = childTree;
      }
      this.treeData = finalTree;
    },
    //递归整理数据
    recursiveData(treeData, tjson) {
      treeData.forEach(ele => {
        let child = [];
        let code = ele.code;
        if (this.midData.has(code)) {
          this.midData.get(code).forEach(item => {
            let jsonData = this.complieSource(item, tjson);
            child.push(jsonData);
          });
          this.midData.delete(code);
          ele.children = child;
          this.recursiveData(ele.children, tjson);
        }
      });
      return treeData
    },
    complieSource(sourceitem, tjson) {
      let jsonData = {}
      for (let key in tjson) {
        if (key === 'nodetype') {
          if (!IsNull(tjson[key])) {
            jsonData[key] = sourceitem[tjson[key]]
            switch (jsonData[key]) { // 根据节点类型赋值icon
              case 1000:
                jsonData['icon'] = 'icon-fenqu';
                break;
              case 1001:
                jsonData['icon'] = 'icon-zuzhi';
                break;
              case 1002:
                jsonData['icon'] = 'icon-xiaoqu';
                break;
              case 1003:
                jsonData['icon'] = 'icon-loudong';
                break;
              case 1004:
                jsonData['icon'] = 'icon-danyuan';
                break;
              case 1005:
                jsonData['icon'] = 'icon-dmafenqu';
                break;
              case 1006:
                jsonData['icon'] = 'icon-dmaxiaoqu';
                break;
                case 1007:
                jsonData['icon'] = 'icon-quanbukehu';
                break;
                case 1008:
                jsonData['icon'] = 'icon-kehu';
                break;
            }
          }
        } else if (key === "extra") {
          if (tjson.extra.length > 0) {
            jsonData.extra = {};
            tjson.extra.forEach(ele => {
              jsonData.extra[ele] = sourceitem[ele]
            });
          }

        } else if (key === "iconCust") {
          if (tjson.iconCust.length > 0) {
            jsonData.iconCust = {};
            tjson.iconCust.forEach(ele => {
              jsonData.iconCust[ele] = sourceitem[ele]
            });
          }
        } else {
          if (!IsNull(tjson[key])) {
            jsonData[key] = sourceitem[tjson[key]]
          }
        }
      }
      return jsonData
    },
  },
  mounted() {
    this.integratedData(this.sourceData, this.formatTreeData)
  },
  activated() {

  },

}
</script>

<style lang="less" scoped>
.tree-box {
  height: calc(100vh - 192px);

  header {
    display: flex;
    justify-content: space-between;
    padding: 10px;
  }

  .treesearch {
    padding: 0px 10px;
  }

  .overauto {
    width: 240px;
    height: 100%;
    overflow: auto;
    padding: 0 10px;

    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 5px rgba(24, 25, 27, 0.2);
      background: rgba(24, 25, 27, 0.2);
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px rgba(24, 25, 27, 0.1);
      background: rgba(24, 25, 27, 0.1);
      border-radius: 0;
    }

    .el-tree {
      min-width: 100%;
      display: inline-block;
      margin-top: 10px;

      .el-tree-node {
        overflow: auto;
      }
    }
  }

  .editIcon {
    display: none;
    margin-left: 5px;

    i {
      margin-right: 5px;
    }
  }

  .treeIcon {
    width: 100%;
    .iconfont {
      margin-right: 4px;
    }
  }
}
.en-US{
    .el-dropdown-menu--small .el-dropdown-menu__item{
        font-size: 12px;
    }
}
.theme2{
    .tree-box{
        .overauto{
            &::-webkit-scrollbar-thumb {
                background: rgba(255, 255, 255, 0.2);
            }
            &::-webkit-scrollbar-corner{
                background-color: rgba(0,0,0,.2);
            }
        }
    }
}
</style>